import React from 'react'
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    popup: {
        padding: '5px',
        backgroundColor: 'white',
        borderRadius: '10px'
    },
    labelStyle: {
        minWidth: 120,
        padding: '2px 10px 2px 2px',
        fontSize: '0.9em'
    },
    valueStyle: {
        padding: theme.spacing(0.1),
        padding: '2px',
        fontSize: '0.9em'
    },
}));

const popup = ({data}) => {

    const classes = useStyles();

    return <table className={classes.popup}>
        {data.map((x, i) => (
            <tr key={i}><td className={classes.labelStyle}>{x[0]}:</td><td className={classes.valueStyle}>{x[1]}</td></tr>
        ))}
    </table>;
}

export default popup;


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/letera/src/components/popup/index.js